var primaryPalette = [0xffffff, 0x030303, 0xd14100];
var secondaryPalette = [0xffffff, 0x030303, 0xfec700];
var gemColors = [0xffffff, 0x2e2852, 0x7f30a2, 0xd46abd, 0x2b7fa0, 0x3e6ab0, 0x3b354e, 0xba13a2, 0xc16219, 0xe99b35, 0xf55200, 0xf8273a];
var wildColors = [0x2c78ea, 0x37d5f3, 0xbb5cf2, 0xe037e9];

function hexToRgb(hex) {
  return [Math.floor(hex / (256 * 256)), Math.floor((hex % (256 * 256)) / 256), hex % 256];
}

function rgbToHex(rgb) {
  return rgb[0] * 256 * 256 + rgb[1] * 256 + rgb[2];
}

function multiplyColor(hex, multiplier) {
  var rgb = hexToRgb(hex);
  rgb[0] *= multiplier;
  rgb[1] *= multiplier;
  rgb[2] *= multiplier;
  return rgbToHex(rgb);
}

function fadeToColor(obj, color, alpha, duration) {
  var currentRGB = hexToRgb(obj.tint);
  var currentAlpha = obj.alpha;
  var targetRGB = hexToRgb(color);
  var targetAlpha = alpha;
  obj.fadeColorId = obj.fadeColorId || 0;
  obj.fadeColorId++;
  var fadeColorId = obj.fadeColorId;
  for (var i = 0; i <= duration; i += 20) {
    if (i > duration - 20) {
      i = duration;
    }
    var newRGB = [];
    newRGB[0] = Math.round(currentRGB[0] + (targetRGB[0] - currentRGB[0]) * (i / duration));
    newRGB[1] = Math.round(currentRGB[1] + (targetRGB[1] - currentRGB[1]) * (i / duration));
    newRGB[2] = Math.round(currentRGB[2] + (targetRGB[2] - currentRGB[2]) * (i / duration));
    var newHex = rgbToHex(newRGB);
    var newAlpha = currentAlpha + (targetAlpha - currentAlpha) * (i / duration);
    setTimeout(
      function (o, c, a, id) {
        if (id != o.fadeColorId || o == undefined) return;

        o.tint = c;
        o.alpha = a;
      },
      i,
      obj,
      newHex,
      newAlpha,
      fadeColorId
    );
  }
}
